import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useEffectivePermissions } from "../hooks/useEffectivePermissions";
import { canOpenPage, pagePermission } from "../pageAccess";
import { QueryErrorState } from "@/components/ui/QueryErrorState";

export function PageAccess({ children }: { children: ReactNode }) {
  const { pathname, search } = useLocation();
  const ministryId = pathname === "/services" ? new URLSearchParams(search).get("ministry_id") : null;
  const query = useEffectivePermissions(ministryId);
  if (!pagePermission(pathname)) return children;
  if (query.isPending) return <p>Loading permissions...</p>;
  if (query.isError) return <QueryErrorState title="Unable to load permissions" onRetry={() => void query.refetch()} />;
  if (!canOpenPage(pathname, query.permissions)) {
    return <QueryErrorState title="Access denied" description="You do not have permission to view this Main Church page. Contact your church administrator if your access needs to change." />;
  }
  return children;
}
